<template>
  <div>
    <div v-if="!userAgent">
      <!-- banner -->
      <div class="banner">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs">
        <div class="a-title">
          <el-tabs v-model="activeName" @tab-click="tabClick">
            <template v-for="(item,index) in content">
              <el-tab-pane :label="item.category_name" :key="index">
                <div v-html="item.content" class='content'></div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- banner -->
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs1">
         <div class="a-title1">
          <el-tabs v-model="activeName" @tab-click="tabClick">
            <template v-for="(item,index) in content">
              <el-tab-pane :label="item.category_name" :key="index">
                <div v-html="item.content"></div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div> 
    </div>
  </div>
</template>
<script>
export default {
  name: "Serve",
  data() {
    return {
      activeName: "0",
      image: "",
      content: [],
    };
  },

  // },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.b);
        this.activeName = this.$route.query.b;
      },
      deep: true,
    },
  },
  mounted() {
    this.activeName = this.$route.query.b;
    // 轮播
    this.getBannel();
    // 主要内容
    this.getContent();
  },
  methods: {
    // tabs切换
    tabClick: function (tab) {
      let url = "/serve?b=" + tab.name;
      this.$root.newVue.$emit("nav_index", url);
    },
    // 轮播
    getBannel() {
      let that = this;
      that.$http.get("images/services").then(function (res) {
        that.image = res.data.data.image;
      });
    },
    // 主要内容
    getContent() {
      let that = this;
      that.$http.get("services/index_all").then(function (res) {
        that.content = res.data.data;
        console.log("服务内容", res.data.data);
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.tabs .a-title .content{
     line-height: 2rem;
     text-align: justify;
     font-family: PingFangSC-Semibold, PingFang SC;
      font-size: 14px;
      margin-top:3%;
      padding-bottom: 2rem;
}
.banner1 {
  width: 100%;
  img {
    width: 100%;
    height: 7rem;
  }
}
.tabs1 .tabs-title1 {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .title1 {
    div {
      line-height: 2rem;
      text-align: justify;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
    }
  }
  .img1 {
    width: 100%;
    margin: 0 auto;
    margin-top: 3%;
    padding-bottom: 5%;
    img {
      width: 100%;
    }
  }
}
</style>
<style>
.tabs .el-tabs__item {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
.tabs .el-tabs__content {
  overflow: hidden;
  position: relative;
  top: 0;
  bottom: 0;
  margin-top: -1%;
  padding-bottom: 0;
  width: 100%;
}
.tabs .tabs-title .title[data-v-4e56fc25] {
  margin: 0 auto;
  padding-top: 4rem;
}
.tabs .tabs-title .img[data-v-4e56fc25] {
  width: 100%;
  margin: 0 auto;
  margin-top: 3%;
  padding-bottom: 5%;
}
.tabs .tabs-title .img[data-v-4e56fc25] {
  width: 100%;
}
.tabs1 .el-tabs__nav-scroll {
  padding-bottom: 6px;
  height: 3rem;
  line-height: 3rem;
}
.tabs1 .el-tabs__nav-next {
  right: 0;
  margin-top: 2.5%;
}
.tabs1 .el-tabs__nav-prev {
  left: 0;
  margin-top: 2.5%;
}
.tabs1 .el-tabs__item {
  font-weight: bold !important;
}
.tabs1 .el-tabs__nav-scroll,
.tabs1 .el-tab-pane {
  width: 90%;
  margin: 0 auto;
}
.a-title1 .el-tab-pane div{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.a-title1 .el-tab-pane div p{
  margin-top:2%;
}
.a-title1 .el-tab-pane div p span{
  font-size:11px !important;
}
</style>